import { render, staticRenderFns } from "./ToolbarView.vue?vue&type=template&id=10b97f65&scoped=true"
import script from "./ToolbarView.vue?vue&type=script&lang=js"
export * from "./ToolbarView.vue?vue&type=script&lang=js"
import style0 from "./ToolbarView.vue?vue&type=style&index=0&id=10b97f65&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b97f65",
  null
  
)

export default component.exports